import { LEGACY_HASH_REDIRECTS } from '~/constants/legacyHashRedirects'

// Eski SPA'dan miras kalan hash URL'lerini (`/destek/#/...`) yeni rotaya
// 301 muadili olarak `location.replace` ile yönlendirir. Hash sunucuya
// iletilmediği için bu eşleme yalnızca client'ta yapılabilir; server tarafı
// için server/middleware/legacy-redirects.ts kullanılır.
export default defineNuxtPlugin(() => {
  const redirect = () => {
    const rawHash = window.location.hash
    if (!rawHash || !rawHash.startsWith('#/')) return

    // `#/foo/bar?x=1` → path: `/foo/bar`
    const withoutHash = rawHash.slice(1)
    const rawPath = withoutHash.split('?', 1)[0]!

    let pathname: string
    try {
      pathname = decodeURIComponent(rawPath)
    } catch {
      return
    }

    const target = LEGACY_HASH_REDIRECTS[pathname]
    if (target) {
      window.location.replace(target)
    }
  }

  redirect()
  window.addEventListener('hashchange', redirect)
})
